
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import { withStyles } from '@material-ui/core/styles';
import { documentStyles } from '../../Styles/documentStyles';
import Images from '../../Theme/Images';
import { ReactSVG } from 'react-svg'
//import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Loader from 'react-loader-spinner'
import Rector from '../../Components/Documents/Rector'
import { SizeMe } from 'react-sizeme'
import PageNavbar from '../../Common/PageNavbar';
import TemplateForm from './TemplateForm';

@inject('templateStore', 'imageStore')
@observer
class CurrentTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resetImage: false
        }
        this._areaElement = new Map();
        this._areaElementBack = new Map();
    }

    componentDidMount() {
    this.props.templateStore.getTemplateDetails(this.props.match.params['templateId'])
       /* if (this.props.location.pathname.toLowerCase().split("/template/")[1] !== undefined)
            this.props.templateStore.getTemplateDetails(this.props.location.pathname.toLowerCase().split("/template/")[1])
        else if (this.props.location.templateId === undefined)
            this.props.history.push('/dashboard/templates')
        else
            this.props.templateStore.getTemplateDetails(this.props.location.templateId);*/
    }

    highlight = (event, index) => {
        const { currentPage } = this.props.templateStore;
        this.fitPage()
        this.resetHighlight(false)
        const node = this._areaElement.get(index);
        const { currentWidthImage, getTemplateAspectRatio } = this.props.imageStore;
        const imgHeight = currentWidthImage * getTemplateAspectRatio;

        /* if (node.props.newlyCreated) {
             this.props.templateStore.startDrawPoint(currentPage.labelData[0],
                 currentPage.labelData[1], currentPage.labelData[2],
                 currentPage.labelData[3], { width: currentWidthImage, height: imgHeight }, currentPage.labelData, { w: currentWidthImage, h: imgHeight });
         } else {
        this.setState({
            pointX: currentPage.labelData[0].pts * currentWidthImage,
        }) */
        this.props.imageStore.zoomIn();
        this.props.imageStore.startDrawPoint(currentPage.labelData[index].pts[0] * currentWidthImage,
            currentPage.labelData[index].pts[1] * imgHeight,
            currentPage.labelData[index].pts[2] * currentWidthImage - currentPage.labelData[index].pts[0] * currentWidthImage,
            currentPage.labelData[index].pts[3] * imgHeight - currentPage.labelData[index].pts[1] * imgHeight,
            { width: currentWidthImage - currentPage.labelData[index].pts[0] * currentWidthImage, height: imgHeight - currentPage.labelData[index].pts[1] * imgHeight }, currentPage.labelData[index].pts,
            { w: currentWidthImage, h: imgHeight });
        //}
    }

    highlightBack = (event, index) => {
        const { currentPage } = this.props.templateStore
        this.resetHighlight(false)
        const node = this._areaElementBack.get(index);
        const { currentWidthImage, getTemplateAspectRatio } = this.props.imageStore;
        const imgHeight = currentWidthImage * getTemplateAspectRatio;

        if (node.props.newlyCreated) {
            this.props.imageStore.startDrawPoint(currentPage.labelData[index].pts[0],
                currentPage.labelData[index].pts[1], currentPage.labelData[index].pts[2],
                currentPage.labelData[index].pts[3], { width: currentWidthImage, height: imgHeight }, currentPage.labelData[index], { w: currentWidthImage, h: imgHeight });
        } else {
            this.props.imageStore.startDrawPoint(currentPage.labelData[0] * currentWidthImage,
                currentPage.labelData[index].pts[1] * imgHeight,
                currentPage.labelData[index].pts[2] * currentWidthImage - currentPage.labelData[index].pts[0] * currentWidthImage,
                currentPage.labelData[index].pts[3] * imgHeight - currentPage.labelData[index].pts[1] * imgHeight,
                { width: currentWidthImage, height: imgHeight }, currentPage.labelData[index], { w: currentWidthImage, h: imgHeight }
            );
        }
    }

    resetHighlight(reset) {
        this.setState({
            resetImage: reset
        })
    }

    removeHighlight = (event, index) => {
        this.resetHighlight(true)
        const node = this._areaElement.get(index);
        this.props.imageStore.eraseDrawPoint();
    }

    openDropDown = () => {
        this.props.imageStore.openDocumentDrawer()
    }

    zoomIn = () => {
        if (this.props.templateStore.currentField._id !== undefined)
            this.props.imageStore.zoomIn()
    }

    zoomOut = () => {
        if (this.props.templateStore.currentField._id !== undefined)
            this.props.imageStore.zoomOut()
    }

    fitPage = () => {
        if (this.props.templateStore.currentField._id !== undefined)
            this.props.imageStore.fitPage()
    }

    render() {
        const { classes } = this.props;
        const { currentPage, currentTemplate, inProgress, currentField } = this.props.templateStore;
        if (inProgress)
            return (
                <div className={classes.loaderDiv}><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
            )

        return (
            currentTemplate.pageArray && currentTemplate.pageArray.length ? <div>
                <div className={classes.content} style={{ display: 'flex' }}>
                    <TemplateForm resetImage={this.fitPage} highlight={this.highlight} removeHighlight={this.removeHighlight}></TemplateForm>
                    {<div className={classes.imageDiv}>
                        <SizeMe>{({ size }) =>
                            <div className={classes.imageContainer} id="rector-container">
                                <Rector type="template" resetImage={false} imageContainerWidth={size.width} imageContainerHeight={currentPage.dimension.aspectRatio * (size.width)}
                                        width={currentPage.dimension.width} height={currentPage.dimension.height}
                                        aspectRatio={currentPage.dimension.aspectRatio} imageSrc={currentPage.pageImageLink} onSelected={this.onSelected} />
                                <div className={classes.pageNo}>
                                    Page {currentPage.pageNo}
                                </div>
                                {currentField._id !== undefined ?
                                    <div className={classes.zoomContainer}>
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.zoomIn()}
                                            src={Images.zoomIn} />
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.zoomOut()}
                                            src={Images.zoomOut} />
                                        <ReactSVG disabled
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.fitPage()}
                                            src={Images.fitPage} />
                                    </div> : null}
                            </div>
                        }</SizeMe>
                    </div>}
                </div> 
                <PageNavbar resetImage={this.fitPage} type="template" currentDoc={currentTemplate} currentPage={currentPage}></PageNavbar>
            </div> : null

        )
    }
}
export default withStyles(documentStyles, { withTheme: true })(withRouter(CurrentTemplate));
